import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Services from './pages/Services';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/ScrollToTop';
import NetfluencePopup from './components/NetfluencePopup';
import { useTranslation } from 'react-i18next';
import { PopupProvider } from './context/PopupContext';

// Import all service pages
import TreePruning from './pages/TreePruning';
import Gardening from './pages/Gardening';
import Grasscutting from './pages/Grasscutting';
import SpringFallCleanup from './pages/SpringFallCleanup';
import ParkingLotCleaning from './pages/ParkingLotCleaning';
import HedgeTrimming from './pages/HedgeTrimming';
import SodInstallation from './pages/SodInstallation';
import Relevelling from './pages/Relevelling';
import PaveWalkways from './pages/PaveWalkways';
import PaveUniReleveling from './pages/PaveUniReleveling';
import Excavation from './pages/Excavation';
import SnowRemoval from './pages/SnowRemoval';

// Language wrapper component to handle language changes based on URL
const LanguageWrapper = ({ children }: { children: React.ReactNode }) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const langParam = urlParams.get('lang') || 'en';
    
    if (i18n.language !== langParam && ['en', 'fr'].includes(langParam)) {
      // Change language without manually changing scroll
      i18n.changeLanguage(langParam);
      // Let ScrollToTop component handle the scrolling
    }
  }, [i18n, location.search]);

  return <>{children}</>;
};

// Main app with language wrapper
const AppWithLanguage = () => {
  return (
    <div className="overflow-x-hidden relative">
      <ScrollToTop />
      <LanguageWrapper>
        <Routes>
          {/* Main routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/gallery" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contactfb" element={<Contact />} />
          
          {/* Service page routes */}
          <Route path="/services/tree-pruning" element={<TreePruning />} />
          <Route path="/services/gardening" element={<Gardening />} />
          <Route path="/services/grasscutting" element={<Grasscutting />} />
          <Route path="/services/spring-fall-cleanup" element={<SpringFallCleanup />} />
          <Route path="/services/parking-lot-cleaning" element={<ParkingLotCleaning />} />
          <Route path="/services/hedge-trimming" element={<HedgeTrimming />} />
          <Route path="/services/sod-installation" element={<SodInstallation />} />
          <Route path="/services/relevelling" element={<Relevelling />} />
          <Route path="/services/pave-walkways" element={<PaveWalkways />} />
          <Route path="/services/pave-uni-releveling" element={<PaveUniReleveling />} />
          <Route path="/services/excavation" element={<Excavation />} />
          <Route path="/services/snow-removal" element={<SnowRemoval />} />
          
          <Route path="*" element={<NotFound />} />
        </Routes>
      </LanguageWrapper>
      <NetfluencePopup />
    </div>
  );
};

function App() {
  return (
    <Router>
      <PopupProvider>
        <AppWithLanguage />
      </PopupProvider>
    </Router>
  );
}

export default App;
